export const Billboard = {
	Single: "single",
	Double: "double",
} as const;
export type Billboard = (typeof Billboard)[keyof typeof Billboard];

export const TreeType = {
	Deciduous: "deciduous",
	Evergreen: "evergreen",
} as const;
export type TreeType = (typeof TreeType)[keyof typeof TreeType];
